import React, { useState, useContext, useEffect } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import AuthContext from "../../Context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";

function EditResidenceDiscount() {
  const [residence, setResidence] = useState();
  const [discount, setDiscount] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  let { rid } = useParams();

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/residences/${rid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setResidence(response.data.residence);
      setDiscount(response.data.residence.discount);
      setIsLoading(false);
    }
    fetch();
  }, []);

  const handleDiscountChange = (evt) => {
    setDiscount(evt.target.value);
  };

  const handleSubmit = async () => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/residences/update/discount/${rid}`,
        data: {
          discount: discount,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/residences");
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return <Spinner animation="border" />;
  } else {
    return (
      <Col className="new-residence">
        <Col>
          <h4>Editar descuento de la residencia</h4>
        </Col>
        <Col className="new-residence-form">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Descuento anual al momento</Form.Label>
              <Form.Control
                type="number"
                onChange={handleDiscountChange}
                value={discount}
              />
            </Form.Group>
            <Form.Group>
              <Button variant="info" onClick={handleSubmit}>
                Guardar
              </Button>
              <Button variant="danger" onClick={() => navigate("/residences")}>
                Cancelar
              </Button>
            </Form.Group>
          </Form>
        </Col>
      </Col>
    );
  }
}

export default EditResidenceDiscount;
